const YN = ["Yes", "No"];

const employer = (n, heading) => ({
  title: heading,
  fields: [
    { name: `emp${n}_title`, label: "Job title", span: 3 },
    { name: `emp${n}_from`, label: "Dates employed — from", type: "month", span: 1 },
    { name: `emp${n}_to`, label: "To", type: "month", span: 1 },
    { name: `emp${n}_hours`, label: "If part-time, hrs/wk", span: 1 },
    { name: `emp${n}_type`, label: "Employment type", type: "radio", options: ["Full time", "Part-time"], span: 2 },
    { name: `emp${n}_org`, label: "Organization name and address", span: 4 },
    { name: `emp${n}_start_salary`, label: "Starting salary", span: 2 },
    { name: `emp${n}_final_salary`, label: "Final salary", span: 2 },
    { name: `emp${n}_contact_refs`, label: "Contact my current references", type: "radio", options: ["At any time", "Only if I am a finalist candidate"], span: 2 },
    { name: `emp${n}_supervisor`, label: "Supervisor's name, title and phone #", span: 3 },
    { name: `emp${n}_other_ref`, label: "Other reference name, title and phone #", span: 3 },
    { name: `emp${n}_contact_info`, label: "Employer phone / email", span: 3 },
    { name: `emp${n}_may_contact`, label: "May we contact this employer?", type: "radio", options: YN, span: 3 },
    { name: `emp${n}_duties`, label: "Primary duties", type: "textarea", span: 4 },
    { name: `emp${n}_reason`, label: "Reason for leaving", type: "textarea", span: 2 },
  ],
});

export const SECTIONS = [
  {
    id: "01", title: "Applicant Information", short: "Applicant",
    fields: [
      { name: "last_name", label: "Last name", required: true, span: 2, autoComplete: "family-name" },
      { name: "first_name", label: "First name", required: true, span: 2, autoComplete: "given-name" },
      { name: "middle_name", label: "Middle name", span: 2, autoComplete: "additional-name" },
      { name: "other_names", label: "Other names under which you have attended school or been employed", span: 6 },
      { name: "street", label: "Street address", span: 3, autoComplete: "street-address" },
      { name: "city_state_zip", label: "City, State & ZIP", span: 3 },
      { name: "phone", label: "Primary / home phone", type: "tel", required: true, span: 2, autoComplete: "tel" },
      { name: "work_phone", label: "Work phone", type: "tel", span: 2 },
      { name: "other_phone", label: "Other phone", type: "tel", span: 2 },
      { name: "email", label: "Email address", type: "email", required: true, span: 4, autoComplete: "email" },
      { name: "application_date", label: "Application date", type: "date", span: 2 },
    ],
  },
  {
    id: "02", title: "Position and Availability", short: "Position",
    fields: [
      { name: "position_requested", label: "Position(s) requested", type: "checkbox", span: 6, options: ["Registered Nurse (RN)", "Licensed Practical Nurse (LPN)", "Certified Nursing Assistant (CNA)", "Geriatric Nursing Assistant (GNA)", "Certified Medication Technician (CMT)", "Home Health Aide", "Other"] },
      { name: "other_specialty", label: "Other position / specialty", span: 4 },
      { name: "job_number", label: "Job # (if known)", span: 2 },
      { name: "employment_preference", label: "Employment preference", type: "checkbox", options: ["Full-time", "Part-time", "PRN / as needed", "Temporary"], span: 3 },
      { name: "preferred_shifts", label: "Preferred shifts", type: "checkbox", options: ["Day", "Evening", "Night", "Overnight / live-in"], span: 3 },
      { name: "earliest_start", label: "Earliest start date", type: "date", span: 2 },
      { name: "desired_rate", label: "Desired hourly rate", span: 2 },
      { name: "reliable_travel", label: "Can you reliably travel to assigned locations?", type: "radio", options: YN, span: 2 },
      { name: "days_hours", label: "Days and hours available", span: 3 },
      { name: "pref_locations", label: "Preferred assignment locations", span: 3 },
    ],
  },
  {
    id: "03", title: "Work Eligibility and General Information", short: "Eligibility",
    fields: [
      { name: "work_eligible_us", label: "Are you eligible to work in the United States?", type: "radio", options: YN, required: true, span: 3 },
      { name: "work_auth_type", label: "Work authorization status", type: "radio", options: ["U.S. Citizen", "Permanent Resident", "Work Permit / EAD", "Other visa"], span: 3 },
      { name: "work_permit_category", label: "Work permit category (e.g. C08), if applicable", span: 3 },
      { name: "work_permit_exp", label: "Work permit expiration date", type: "date", span: 3 },
      { name: "age_18", label: "Are you 18 years of age or older?", type: "radio", options: YN, span: 3 },
      { name: "current_age", label: "If NO, what is your current age?", span: 3 },
      { name: "current_elevion", label: "Are you currently employed at Elevion Care Network?", type: "radio", options: YN, span: 3 },
      { name: "current_elevion_title", label: "If YES, current job title & department", span: 3 },
      { name: "prior_elevion", label: "Have you ever been employed by Elevion Care Network?", type: "radio", options: YN, span: 3 },
      { name: "prior_elevion_dates", label: "If YES, dates of employment & reason for leaving", span: 3 },
      { name: "related_employee", label: "Are you related to any current Elevion employee?", type: "radio", options: YN, span: 3 },
      { name: "related_name", label: "If YES, their name & relationship to you", span: 3 },
      { name: "drivers_license", label: "If required for position, do you have a valid driver's license?", type: "radio", options: YN, span: 3 },
      { name: "dl_state", label: "State of issuance", span: 1 },
      { name: "dl_exp", label: "Expiration date", type: "date", span: 2 },
      { name: "referral_source", label: "How did you learn about this employment opportunity? (check all that apply)", type: "checkbox", options: ["Ad in newspaper", "Job bulletin (posting) / walk-in", "Website", "Dept. of Labor", "Referral by employee", "Other"], span: 4 },
      { name: "referral_other", label: "Referral name / other source", span: 2 },
    ],
  },
  {
    id: "04", title: "Education and Training", short: "Education",
    table: {
      name: "edu",
      rows: ["High School", "GED", "Other School", "College", "College (2)", "College (3)"],
      cols: [
        { key: "school", label: "Name of school" },
        { key: "city_state", label: "City / State" },
        { key: "graduated", label: "Did you graduate?", type: "yn" },
        { key: "years_left", label: "If no, # of years left" },
        { key: "grad_date", label: "If yes, date of graduation" },
        { key: "degree", label: "Degree received" },
        { key: "major", label: "Major" },
      ],
    },
    fields: [
      { name: "other_credentials", label: "Other credentials / licenses / professional affiliations relevant to the job(s) for which you are applying", type: "textarea", span: 3 },
      { name: "specialties_training", label: "Specialties / additional training", type: "textarea", span: 3 },
    ],
  },
  {
    id: "05", title: "Professional Licenses and Certifications", short: "Licenses",
    note: "List license numbers only — do not upload license scans here.",
    table: {
      name: "lic",
      rows: ["License / certification 1", "License / certification 2", "License / certification 3"],
      cols: [
        { key: "type", label: "Type (RN, LPN, CNA, GNA, CMT…)" },
        { key: "number", label: "Number" },
        { key: "state", label: "Issuing state" },
        { key: "exp", label: "Expiration", type: "date" },
        { key: "status", label: "Status" },
      ],
    },
    fields: [
      { name: "cpr_status", label: "CPR certification (BIS)", type: "radio", options: ["Current", "Expired", "Not certified"], span: 3 },
      { name: "first_aid_status", label: "First Aid certification (BIS)", type: "radio", options: ["Current", "Expired", "Not certified"], span: 3 },
    ],
  },
  {
    id: "06", title: "Skills and Care Settings", short: "Skills",
    note: "List technical, clerical, trade or clinical skills relevant to this position, including computer systems and software, and note your level of proficiency.",
    table: {
      name: "skill",
      rows: ["Skill 1", "Skill 2", "Skill 3", "Skill 4"],
      cols: [
        { key: "name", label: "Skill / system / software" },
        { key: "level", label: "Proficiency", type: "select", options: ["Basic", "Intermediate", "Expert"] },
      ],
    },
    fields: [
      { name: "relevant_skills", label: "Relevant skills", type: "checkbox", options: ["Personal care", "Transfers and mobility", "Dementia support", "Vital signs", "Documentation", "Medication reminders"], span: 6 },
      { name: "additional_experience", label: "Additional experience", type: "checkbox", options: ["Hospice / end-of-life", "Pediatrics", "Behavioral health", "Post-surgical recovery", "Meal preparation", "Companionship"], span: 6 },
      { name: "care_settings", label: "Care settings worked", type: "checkbox", options: ["Home Care", "Assisted Living", "Long-Term Care", "Hospital"], span: 4 },
      { name: "years_exp", label: "Years of experience", span: 2 },
      { name: "languages", label: "Languages spoken", span: 6 },
    ],
  },
  {
    id: "07", title: "Employment History — Current or Most Recent", short: "Employer 1",
    note: "Please detail your entire work history, beginning with your current or most recent employer. If you held multiple positions with the same organization, detail each separately. Explain any gaps in employment and include full-time military or volunteer commitments. Please do not complete this section with \"See Resume.\" Omission of prior employment may be considered falsification of information. Elevion Care Network LLC reserves the right to contact all current and former employers for reference information.",
    groups: [employer(1, "Employer 1 (current / most recent)")],
  },
  {
    id: "08", title: "Employment History — Previous Employers", short: "Employers 2–3",
    groups: [employer(2, "Employer 2"), employer(3, "Employer 3")],
    fields: [{ name: "employment_gaps", label: "Explanation of any gaps in employment", type: "textarea", span: 6 }],
  },
  {
    id: "09", title: "Professional References, Emergency Contact & Resume", short: "References",
    table: {
      name: "ref",
      rows: ["Reference 1", "Reference 2"],
      cols: [
        { key: "name", label: "Name" },
        { key: "title_org", label: "Title / organization" },
        { key: "phone_email", label: "Phone / email" },
        { key: "relationship", label: "Relationship" },
      ],
    },
    fields: [
      { name: "emergency_name", label: "Emergency contact name", span: 3 },
      { name: "emergency_relationship", label: "Relationship", span: 1 },
      { name: "emergency_phone", label: "Telephone number", type: "tel", span: 2 },
      { name: "accompanying_docs", label: "Accompanying documents (describe)", type: "textarea", span: 6 },
    ],
    resume: true,
  },
  {
    id: "10", title: "Applicant Certification, Consent and Signature", short: "Sign & send",
    certification: true,
    fields: [
      { name: "signature", label: "Applicant signature (type full legal name)", required: true, span: 3, placeholder: "Type full name as electronic signature" },
      { name: "sign_date", label: "Date", type: "date", span: 1 },
      { name: "printed_name", label: "Printed name", required: true, span: 2 },
    ],
  },
];

export const EEO_TEXT = "Elevion Care Network LLC is an Equal Opportunity Employer. Employment offers are made based on qualifications and without regard to race, color, sex, religion, national or ethnic origin, disability, age, veteran status, sexual orientation, or any other status protected by law.";

export const CERT_PARAGRAPHS = [
  "I certify that the information provided on this application and in all supporting documents is accurate and complete. I understand and agree that failure to fully complete this form, or any misrepresentation or omission of facts, may result in disqualification from consideration for employment or termination of employment if discovered at a later date.",
  "I authorize Elevion Care Network LLC to investigate, without liability, all statements contained in this application and supporting materials. I also authorize references and former employers to respond fully, without liability, to any inquiries regarding my application for employment.",
  "If requested, I agree to submit to a physical examination, criminal background investigation, credit background investigation, and/or screening for illegal substances upon receipt of a conditional offer of employment.",
  "I understand that this document is not an offer of employment and that any offer of employment, if extended, does not constitute a contract for continued or guaranteed employment. I further understand that employees of Elevion Care Network LLC are employed at will, and the employment relationship may be terminated at any time by either party, with or without cause or notice, except as prohibited by law.",
  "If employed, I will be required to provide proof of eligibility to work in the United States. I understand that if employed on a temporary basis, I will be compensated only for hours worked and will not be eligible for benefits, including paid time off.",
  "If employed in a regular, benefits-eligible position, I understand that I may be required to make mandatory contributions to designated organizations. I also understand that any benefits I receive may be modified or discontinued at any time without prior notice.",
];

export function allFields(s) {
  const out = [];
  if (s.table) {
    s.table.rows.forEach((row, r) => s.table.cols.forEach((c) => out.push({ name: `${s.table.name}_${r}_${c.key}`, label: `${row} — ${c.label}`, type: c.type === "yn" ? "radio" : c.type })));
  }
  (s.groups || []).forEach((g) => g.fields.forEach((f) => out.push({ ...f, label: `${g.title} — ${f.label}` })));
  (s.fields || []).forEach((f) => out.push(f));
  return out;
}

export const SENSITIVE = SECTIONS.flatMap(allFields).filter((f) => f.sensitive).map((f) => f.name);
